<template>
  <div class="plan-start" v-title :data-title='"卓考网校|"+name+"|执行"'>
    <main class="g-view-container">
      <!-- navbar -->
      <van-nav-bar :title="shortName" left-arrow @click-left="onReturn">
        <van-dropdown-menu v-if="isDivide" slot="right">
          <van-dropdown-item v-model="courseId" :options="courseList" />
        </van-dropdown-menu>
      </van-nav-bar>

      <!-- tabs -->
      <van-tabs v-model="stageIndex" :ellipsis="false">
        <template v-for="(item, index) in stageNameList">
          <van-tab :key="index" :title="item" />
        </template>
      </van-tabs>

      <!-- notice -->
      <van-notice-bar :text="startTime" left-icon="volume-o" background="#5eabfd" color="#fff" />

      <!-- stage -->
      <div class="stage">
        <template v-for="(item,index) in stageBody">
          <stage-item :key="index" :week="item.week" :items="item.detail" />
        </template>
      </div>
    </main>
  </div>
</template>

<script>
  import planModel from 'models/plan';
  import courseModel from 'models/course';
  import StageItem from './item';

  export default {
    name: 'Start',
    data() {
      return {
        professionId: this.$route.params.professionId,
        planType: this.$route.params.planType,
        courseId: '1',
        stageIndex: 0,
        title: '',
        isDivide: false,
        stage: [],
      };
    },
    components: {
      StageItem,
    },
    computed: {
      courseList() {
        const courseList = courseModel.getCourseListById(this.professionId);
        if (courseList.length > 0) {
          const newList = courseList.map(item => ({
            value: item.id,
            text: item.name,
          }));
          return newList;
        }
        return [];
      },
      stageNameList() {
        const list = [];
        this.stage.forEach((item) => {
          list.push(item.name);
        });
        return list;
      },
      startTime() {
        if (this.stage[this.stageIndex]) {
          return this.stage[this.stageIndex].startTime;
        }
        return '';
      },
      stageBody() {
        if (this.stage[this.stageIndex]) {
          if (this.isDivide) {
            return this.stage[this.stageIndex].body[this.courseId];
          }
          return this.stage[this.stageIndex].body;
        }
        return [];
      },
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        const plan = planModel.getPlan(this.professionId, this.planType);
        if (!plan.start.isOpen) {
          this.$router.replace('/');
        } else {
          this.name = plan.name;
          this.shortName = plan.shortname;
          this.isDivide = plan.start.isDivide;
          this.stage = plan.start.stage;
          if (this.isDivide) {
            this.courseId = this.courseList[0].value;
          }
        }
      },
      onReturn() {
        this.$router.go(-1);
      },
    },
  };
</script>


<style lang="scss" scoped>
.plan-start {
  /* 修改 van-nav-bar 和 van-dropdown-menu 的一些默认样式 */
  .van-nav-bar {
    background-color: #2d92fe;

    &__title {
      color: #fff;
    }

    .van-icon {
      color: #fff;
    }

    .van-dropdown-menu {
      position: relative;
      background-color: #2d92fe;

      ::v-deep .van-dropdown-menu__title {
        color: #fff;
      }
    }
  }
  .van-tabs {
    ::v-deep .van-tabs__line {
      z-index: 0;
    }
  }

  .van-notice-bar {
    margin: 10px 0 0 10px;
    width: 60%;
    height: auto;
    border-radius: 20px;
  }
}
</style>
